import { useState } from 'react';
import uuidv4 from 'uuid/v4';

const useSliderKey = () => {
  const [sliderKey, setSliderKey] = useState(uuidv4());

  /* NOTE: setTimeout should only happen in useEffect as the callback may run after the component is unmounted */
  /* In this case the memory leak incurred is probably better than the ugly hook that would have to exist to fix it */
  /* we should be looking for a better way to handle updates to the slider than fix a workaround though */

  const regenerateSliderKey = () => {
    // used to force the slider to re-render when it needs to update because the
    // values have changed. We don't want this to happen automatically as
    // the slider will re-render as it's dragged.
    // There may be a better way to do this but forcing it into a later
    // event loop will let the slider value state update before it
    // re-renders the slider
    setTimeout(() => {
      setSliderKey(uuidv4());
    });
  };

  return { sliderKey, regenerateSliderKey };
};

export default useSliderKey;
